// assets
import {
  IconDashboard,
  IconPackageImport,
  IconCalculator,
  IconWeight,
  IconBox,
  IconCash,
  IconTruck,
  IconFileInvoice,
  IconChartBar
} from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

const icons = {
    IconDashboard: IconDashboard,
    IconPackageImport: IconPackageImport,
    IconCalculator: IconCalculator,
    IconWeight: IconWeight,
    IconCash: IconCash,
    IconTruck: IconTruck,
    IconFileInvoice: IconFileInvoice,
    IconChartBar: IconChartBar,
    IconBox: IconBox
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const operations: NavItemType = {
    id: 'operations',
    title: 'Operations',
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'shipments',
            title: 'Shipments',
            type: 'item',
            url: '/customer/shipment',
            icon: icons.IconTruck,
            breadcrumbs: false
        },
        {
            id: 'ndr',
            title: 'NDR',
            type: 'item',
            url: '/ndr',
            icon: icons.IconPackageImport,
            breadcrumbs: false
        },
        {
            id: 'rate_calculator',
            title: 'Rate Calculator',
            type: 'item',
            url: '/shipmentCalculator',
            icon: icons.IconCalculator,
            breadcrumbs: false
        },
        {
            id: 'weight_discrepancy',
            title: 'Weight Discrepancy',
            type: 'item',
            url: '/weightdiscrepency',
            icon: icons.IconWeight,
            breadcrumbs: false
        },
        {
            id: 'lost_and_damage',
            title: 'Lost and Damage',
            type: 'item',
            url: '/lostanddamage',
            icon: icons.IconBox,
            breadcrumbs: false
        },
        {
            id: 'cod_management',
            title: 'Manage COD',
            type: 'item',
            url: '/codManagement',
            icon: icons.IconCash,
            breadcrumbs: false
        },
        {
            id: 'invoices',
            title: 'Invoices',
            type: 'item',
            url: '/invoices',
            icon: icons.IconFileInvoice,
            breadcrumbs: false
        },
        {
            id: 'reports',
            title: 'Reports',
            type: 'item',
            url: '/reports',
            icon: icons.IconChartBar,
            breadcrumbs: false
        }
    ]
};

export default operations;
